export default "__VITE_ASSET__DRbBTxIi__"